import PropTypes from "prop-types";
import { cn } from "../../../Utils/helper";
import { useNavigate } from "react-router-dom";

const Search = ({
  searchQuery = "",
  onSearchChange,
  onFavoriteToggle,
  showFavorites = false,
  showClear = false,
  isFavorited = false,
  placeholder,
  className = "",
  ...props
}) => {
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    if (onSearchChange) {
      onSearchChange(e.target.value);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    // if (onFavoriteToggle) {
    //   onFavoriteToggle();
    // }
    navigate("/favorites");
  };

  return (
    <div className={cn(`relative w-full ${className}`)} {...props}>
      <div className="flex gap-2 items-center bg-white rounded-lg h-[50px] px-3 border border-mid-gray transition-all duration-200 ">
        <div className="w-6 flex justify-center items-center">
          <span className="icon icon-search text-xl text-mid-gray" />
        </div>

        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={placeholder || ""}
          className="flex-1 outline-none bg-transparent placeholder:text-mid-gray text-base font-medium "
        />
        {showFavorites && (
          <button
            onClick={handleFavoriteClick}
            className="flex-shrink-0 flex items-center p-1 hover:scale-110 transition-transform duration-200"
          >
            <span
              className={`icon text-xl ${
                isFavorited ? "icon-heart-active text-primary" : "icon-heart text-mid-gray"
              }`}
            />
          </button>
        )}

        {showClear && searchQuery && (
          <button
            onClick={() => onSearchChange("")}
            className="flex-shrink-0 flex items-center p-1 hover:scale-110 transition-transform duration-200"
          >
            <span className="icon icon-circle-x text-lg text-mid-gray" />
          </button>
        )}
      </div>
    </div>
  );
};

Search.propTypes = {
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func,
  onFavoriteToggle: PropTypes.func,
  showFavorites: PropTypes.bool,
  isFavorited: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default Search;
